import { createAction } from "@reduxjs/toolkit";
import { TMessage } from "models/message";
import { TPagination } from "modules/api/type";

import { IChangelogData } from "../../components/Version";
import { setNewMessage } from "./messageSlice";

interface MessageState {
  newMessage: number;
  messageList: {
    loading: boolean;
    data: TMessage[];
    pagination: TPagination;
    error: Error | null | unknown;
  };
}

interface DeleteMessagePayload {
  id: number;
  params: object;
}

interface MessageMarkAsReadPayload {
  id: number;
  markReadAs: boolean;
  params: object;
}

interface NewMessageSuccessPayload {
  count?: number;
}

interface ChangelogResponse {
  currentVersion: string | number;
  changelog: IChangelogData[];
}

interface MessageListDonePayload {
  data?: MessageState["messageList"]["data"];
  pagination?: TPagination;
  error?: MessageState["messageList"]["error"];
}

const newMessageAction = createAction("message/new");
const messageListAction = createAction<object>("message/list");
const messageDeleteAction = createAction<DeleteMessagePayload>("message/delete");
const messageMarkAsReadAction = createAction<MessageMarkAsReadPayload>("message/mark-as-read");

export {
  ChangelogResponse,
  DeleteMessagePayload,
  messageDeleteAction,
  messageListAction,
  MessageListDonePayload,
  messageMarkAsReadAction,
  MessageState,
  newMessageAction,
  NewMessageSuccessPayload,
  setNewMessage,
};
